import { CatalogProduct } from "src/app/models/portal.model";
import { ReduxWrapper } from "../app.state";

export class CatalogState {
	theme!: ReduxWrapper<CatalogProduct[]>
	webpart!: ReduxWrapper<CatalogProduct[]>
	template!: ReduxWrapper<CatalogProduct[]>
	accessibility!: ReduxWrapper<CatalogProduct[]>
}

export const productTypeDefaultValue: ReduxWrapper<CatalogProduct[]> = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	value:[]
};

export const catalogInitialState: CatalogState = {
	theme: productTypeDefaultValue,
	webpart: productTypeDefaultValue,
	template: productTypeDefaultValue,
	accessibility: productTypeDefaultValue
};
